import React from "react";

/**
 * ProductBadge - terminal/hacker style branded badge
 * Mimics Autodesk product badges: top section with large letter, bottom strip with abbreviation.
 */
export default function ProductBadge({ text = "?", subText, color = "#00FF66", size = "md" }) {
  const tile = size === "sm" ? "w-14 h-16" : size === "lg" ? "w-44 h-52" : "w-28 h-32";
  const main = size === "sm" ? "text-2xl" : size === "lg" ? "text-7xl" : "text-4xl";
  const sub = size === "sm" ? "text-[8px]" : size === "lg" ? "text-base" : "text-[10px]";

  const dark = shade(color, -25);
  const darker = shade(color, -40);

  return (
    <div className="w-full h-full flex items-center justify-center relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background: `radial-gradient(circle at 30% 30%, ${color}22, transparent 60%), #050505`,
        }}
      />
      <div className="absolute inset-0 bg-grid opacity-25" />
      <div
        className={`relative ${tile} flex flex-col rounded-xl overflow-hidden shrink-0`}
        style={{
          boxShadow: `0 18px 50px -12px ${color}66, inset 0 1px 0 rgba(255,255,255,0.18)`,
        }}
      >
        {/* Top tile */}
        <div
          className={`flex-1 flex items-center justify-center font-heading font-extrabold text-white tracking-tight ${main} relative`}
          style={{
            background: `linear-gradient(140deg, ${color} 0%, ${dark} 100%)`,
          }}
        >
          {text}
          {/* Folded corner accent */}
          <div
            className="absolute top-0 right-0 w-3 h-full"
            style={{ background: `linear-gradient(180deg, ${shade(color, 8)} 0%, ${dark} 100%)`, opacity: 0.55 }}
          />
        </div>
        {/* Bottom strip */}
        <div
          className={`px-2 py-1.5 font-heading font-bold text-white tracking-wider ${sub} text-center`}
          style={{ background: `linear-gradient(180deg, ${darker} 0%, ${shade(color, -55)} 100%)` }}
        >
          {subText || text}
        </div>
      </div>
    </div>
  );
}

function shade(hex, percent) {
  const h = hex.replace("#", "");
  const num = parseInt(h, 16);
  let r = (num >> 16) + Math.round((percent / 100) * 255);
  let g = ((num >> 8) & 0xff) + Math.round((percent / 100) * 255);
  let b = (num & 0xff) + Math.round((percent / 100) * 255);
  r = Math.max(0, Math.min(255, r));
  g = Math.max(0, Math.min(255, g));
  b = Math.max(0, Math.min(255, b));
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
